export default __webpack_public_path__ + "static/media/footer.b19cdd9b.png";